<template>
  <div>
    <Toolbar
      :handle-submit="onSendProdFileForm"
      :handle-reset="resetForm"
      :handle-delete="del"
      >
        <template slot="left">
          <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
            <h1><v-icon large>mdi-qrcode</v-icon>{{$t('profile.material.productversion')}}</h1>
          </v-toolbar-title>
        </template>
    </Toolbar>
    <MaterialProductVersionForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <Loading :visible="isLoading || deleteLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import MaterialProductVersionForm from '../../components/materialproductversion/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';


const servicePrefix = 'MaterialProductVersion';

export default {
  name: 'MaterialProductVersionUpdate',
  servicePrefix,
  mixins: [UpdateMixin],
  components: {
    Loading,
    Toolbar,
    MaterialProductVersionForm
  },

  computed: {
    ...mapFields('materialproductversion', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('materialproductversion', ['find'])

  },

  methods: {
    ...mapActions('materialproductversion', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    }),
    onSendProdFileForm() {
      this.onSendForm();
    //  this.inputfile = this.item.file;
    }
  }
};
</script>
